const PlayerPlayIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4.66663 13.8666C4.59997 13.8666 4.46663 13.8666 4.39997 13.8666C4.26663 13.7999 4.1333 13.5999 4.1333 13.3999V2.66657C4.1333 2.46657 4.19997 2.33324 4.39997 2.1999C4.5333 2.13324 4.7333 2.13324 4.9333 2.1999L13.6 7.53324C13.7333 7.5999 13.8666 7.7999 13.8666 7.93323C13.8666 8.06657 13.8 8.26657 13.6 8.33324L4.9333 13.6666C4.86663 13.6666 4.7333 13.7332 4.66663 13.7332V13.8666ZM5.19997 3.53324V12.3999L12.4 7.93323L5.19997 3.53324Z" fill="currentColor"/>
        </svg>
    )
}

export default PlayerPlayIcon;